<template>
  <ChatLayout>
    <template #content>
      <!-- Phase: decline (unknown sector) -->
      <div v-if="otherText" class="centered-state d-flex flex-column align-center justify-center">
        <p class="text-body-1 grey--text text--darken-2 text-center px-8">{{ otherText }}</p>
        <v-btn text @click="otherText = ''">OK</v-btn>
      </div>

      <!-- Phase: input -->
      <div v-else-if="!sending" class="chat-input pa-md-4 d-flex align-center no-messages">
        <ChatInput @send="onSubmit" />
      </div>

      <!-- Phase: loading (sent, awaiting routing) -->
      <div v-else class="centered-state d-flex flex-column align-center justify-center">
        <div class="logo-pulse">
          <v-img :src="$theme.assets.logoContent"
            width="120"
            contain
            class="mb-3"/>
        </div>
        <div class="thinking mb-3">
          <span class="dot secondary"></span>
          <span class="dot secondary"></span>
          <span class="dot secondary"></span>
        </div>
      </div>

    </template>
  </ChatLayout>
</template>

<script>
import ChatLayout from '@/layout/ChatLayout.vue'
import ChatInput from '@/components/chat/ChatInput.vue'
import { sendAgentInit } from '@/services/agentApi'


export default {
  name: 'NewView',
  components: { ChatLayout, ChatInput },
  data() {
    return {
      sending: false,
      routing: null,
      otherText: '',
      stepDelays: this._randomDelays(),
    }
  },
  methods: {
    _randomDelays() {
      let acc = 0
      return Array.from({ length: 3 }, () => {
        acc += Math.random() * 2 + 1
        return `${acc.toFixed(2)}s`
      })
    },
    onSubmit(text) {
      if (!text) return
      this.stepDelays = this._randomDelays()
      this.sending = true
      let isProject = false

      sendAgentInit(text, {
        onRouting: (stage1, stage2) => {
          this.routing = { stage1, stage2 }
        },
        onPk: (type, pk) => {
          this.$store.commit('chat/SET_INIT_ROUTING', this.routing)
          if (type === 'project') {
            isProject = true
            // Initialise the project shell in the store so ProjectView can
            // render immediately without waiting for a loadProject HTTP round-trip.
            this.$store.commit('project/INIT_QUALIFYING', { id: pk, initialMessage: text })
            this.$store.commit('project/ADD_PROJECT', {
              id: pk,
              title: '',
              domain: '',
              initial_message: text,
              status: 'questioning',
              created_at: new Date().toISOString(),
            })
          }
          const name = type === 'project' ? 'project_detail' : 'chat_detail'
          this.$router.push({ name, params: { id: pk } })
          this.sending = false
        },
        onQuestion: (question) => {
          this.$store.commit('project/APPEND_QUESTION', question)
        },
        onReady: (data) => {
          this.$store.commit('project/FINALIZE_QUALIFYING', {
            domain: data.domain,
            title: data.title,
            projectData: data.project_data,
          })
        },
        onChunk: (chunk) => {
          this.otherText += chunk
        },
        onDone: () => {
          if (!isProject) this.sending = false
        },
        onError: (msg) => {
          this.$store.commit('chat/SHOW_NOTIFICATION', { type: 'error', message: msg }, { root: true })
          this.sending = false
          this.routing = null
        },
      }).catch(err => {
        this.$store.commit('chat/SHOW_NOTIFICATION', { type: 'error', message: err.message || 'Erreur réseau.' }, { root: true })
        this.sending = false
        this.routing = null
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-input {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  &.no-messages {
    height: 100%;
    justify-self: center;
  }
}

.centered-state {
  height: 100%;
}

.thinking {
  display: flex;
  gap: 4px;
}

.dot {
  width: 8px;
  height: 8px;
  background: #bbb;
  border-radius: 50%;
  animation: blink 1.2s infinite ease-in-out;
}

.dot:nth-child(2) { animation-delay: 0.2s; }
.dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes blink {
  0%, 80%, 100% { opacity: 0.2; }
  40% { opacity: 1; }
}

.logo-pulse {
  animation: scale-pulse 2s infinite ease-in-out;
}

@keyframes scale-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.08); }
}

.fade-step {
  opacity: 0;
  animation: fade-in 0.6s ease forwards;
}

@keyframes fade-in {
  to { opacity: 1; }
}
</style>
